import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Organisations } from '../../../api-calls';
import {
  Grid,
  HelpButton,
  Modal,
  Typography as T,
  TextWithIcon,
} from '../../../components';
import { navRoutes as R, roles } from '../../../constants';
import { useAdminOrg } from '../../../context/admin-org';
import { useAuth } from '../../../context/auth';
import PendingDashboard from './PendingDashboard';
import * as S from './style';

const { Col, Row } = Grid;

const Dashboard = () => {
  const [open, setOpen] = useState(false);
  const [orgModalOpen, setOrgModalOpen] = useState(false);
  const { adminOrg } = useAdminOrg();
  const { user } = useAuth();
  const navigate = useNavigate();
  const isSuperAdmin = user.role === roles.SUPER_ADMIN;

  const isPending = adminOrg.status === 'AWAITING_APPROVAL';

  useEffect(() => {
    const getAwaitingApprovalOrganisations = async () => {
      const { data } = await Organisations.getAwaitingApprovalOrganisations();
      if (data) {
        if (data?.length > 0) {
          setOrgModalOpen(true);
        } else {
          setOrgModalOpen(false);
        }
      }
    };

    if (isSuperAdmin) {
      getAwaitingApprovalOrganisations();
    }
  }, [isSuperAdmin]);

  if (isPending && !isSuperAdmin) {
    return <PendingDashboard />;
  }

  return (
    <>
      <Row jc="space-between">
        <Col w={[4, 12, 8]} dir="column" ai="flex-start">
          <T.H1 mtM="5">Welcome</T.H1>
          <T.P
            mt={isSuperAdmin ? '42px' : 6}
            mb={isSuperAdmin ? '40px' : 4}
            color="neutralMain"
          >
            This is the link you will need to share with your clients to access
            the tool
          </T.P>
          <S.LinkWrapper mb={isSuperAdmin && '45px'}>
            <TextWithIcon
              to={`${window.location.origin}`}
              mr={isSuperAdmin ? '15px' : '20px'}
              text={`${window.location.origin}`}
              external
              underline
              weight="medium"
              iconProps={{
                color: 'primaryMain',
                icon: 'open',
              }}
            />
          </S.LinkWrapper>

          {isSuperAdmin && (
            <TextWithIcon
              to={R.ADMIN.EDIT_ACCOUNT_DETAILS}
              text="Edit my organisation details"
              weight="medium"
              iconProps={{
                icon: 'forwardArrow',
                color: 'primaryMain',
              }}
            />
          )}
          {/* {!isSuperAdmin && isApprovedUser && <DashboardLinks />} */}
        </Col>
        <Col w={[4, 12, 4]}>
          {/* <T.H2 mt="3" mtT="7">
            Analytics
          </T.H2>
          <S.AnalysisCardsWrapper>
            <S.AnalysisCard bgColor="neutralLight">
              <T.H1 color="neutralMain">836</T.H1>
              <T.P color="neutralMain">
                Number of times a claims process has been started on my tool
              </T.P>
            </S.AnalysisCard>
            <S.AnalysisCard bgColor="neutralMain">
              <T.H1 color="white">765</T.H1>
              <T.P color="white">
                Number of times everything has been completed on my tool to
                complete a claim
              </T.P>
            </S.AnalysisCard>
            <S.AnalysisCard bgColor="secondaryMain">
              <T.H1 color="white">1,254</T.H1>
              <T.P color="white">Visitors to my tool</T.P>
            </S.AnalysisCard>
          </S.AnalysisCardsWrapper> */}
        </Col>
      </Row>
      <HelpButton
        adminHelp
        parentState={open}
        parentFunc={() => setOpen(false)}
      />
      {isSuperAdmin && (
        <Modal
          visible={orgModalOpen}
          setIsModalVisible={setOrgModalOpen}
          parentFunc={() => navigate(R.SUPER_ADMIN.ORGANISATIONS)}
          title={'Organisations to approve'}
          description={
            'You have organisations awaiting for approval. Please click to review them below. '
          }
          btnText="Review"
        />
      )}
    </>
  );
};

export default Dashboard;
